import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import addPart from '../parts/addPart'
import { platformSpeed } from '../state/globals'
import addVoid from '../parts/addVoid'

k.loadSprite('part', 'sprites/part.png')
k.loadSprite('platform', 'sprites/platform.png')

export default () => {
  k.setGravity(1000)
  k.add([k.sprite('background'), k.fixed()])

  const { partDisplay } = addUI(2)

  const robot = addRobot(true, partDisplay)
  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  addPart(partDisplay, 100, 0)
  addPart(partDisplay, 150, 0)
  addPart(partDisplay, 100, -100)
  addPart(partDisplay, 150, -100)
  addPart(partDisplay, 262, -20)
  addPart(partDisplay, 262, -60)

  addVoid(250)

  k.add([
    k.sprite('grass'),
    k.pos(-20, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  const platform = k.add([
    k.sprite('platform'),
    k.pos(230, -60),
    k.body({ isStatic: true }),
    k.area()
  ])

  let direction = platformSpeed
  platform.onUpdate(() => {
    if (platform.worldPos().y <= -80) direction = platformSpeed
    else if (platform.worldPos().y >= 20) direction = -platformSpeed

    platform.move(k.vec2(0, direction))
  })

  const upperGrass = k.add([
    k.sprite('grass'),
    k.pos(-20, -80),
    k.body({ isStatic: true }),
    k.area()
  ])

  upperGrass.add([
    k.text('Press C to repair', {
      font: 'pixel',
      size: 12
    }),
    k.color(57, 44, 49),
    k.pos(70, -40)
  ])

  const door = upperGrass.add([
    k.sprite('door'),
    k.pos(20, 0),
    k.area(),
    k.anchor('bot'),
    k.z(-1),
    'door'
  ])

  let atDoor = false
  let doorOpen = false

  robot.onCollide('door', () => {
    atDoor = true
    tooltipE.hidden = false
  })
  robot.onCollideEnd('door', () => {
    atDoor = false
    tooltipE.hidden = true
  })
  robot.onKeyPress('e', () => {
    if (atDoor && !doorOpen) {
      doorOpen = true
      door.play('open')
    } else if (atDoor && doorOpen) {
      k.go('three')
    }
  })
}
